import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  bcpSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import {
  alerts,
  helpTooltip,
} from 'app/components/global';

import controller from './edit-schematic-dialog.controller';
import template from './edit-schematic-dialog.html';
import validator, { name as validatorName } from '../messages/schematic-unique-name.validator.directive';
import schematicFileMessagesTpl from '../messages/schematic.file.messages.html';
import schematicNameMessagesTpl from '../messages/schematic.name.messages.html';
import schematicSectionMessagesTpl from '../messages/schematic.section.messages.html';

class dialogService {
  getOptions($event, {
    customerId, assessmentId, schematicSectionId, schematic
  }) {
    return {
      controller,
      controllerAs: 'editSchematicDialogVM',
      locals: {
        customerId,
        assessmentId,
        schematicSectionId,
        schematic
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editSchematicDialog', [
  alerts,
  bcpDataService,
  bcpSharedModelService,
  constants,
  helpTooltip,
  loaderService,
  ssDialogService,
])
  .directive(validatorName, validator)
  .service('editSchematicDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('schematic.name.messages.html', schematicNameMessagesTpl);
    $templateCache.put('schematic.section.messages.html', schematicSectionMessagesTpl);
    $templateCache.put('schematic.file.messages.html', schematicFileMessagesTpl);
  })
  .name;
